// extracted by mini-css-extract-plugin
module.exports = {"screenSizeElem":"App_screenSizeElem__kE5T-"};